import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import { IInadimplenciaFilter, IInadimplenciaRecord, useRelatorioService } from '@services/RelatorioService';
import React from 'react';
import { InadimplenciaDetalhesModal } from './InadimplenciaDetalhesModal';
import { InadimplenciaFilter } from './InadimplenciaFilter';
import { InadimplenciaTable } from './InadimplenciaTable';

export type RelatorioInadimplenciaProps = {

}

export function RelatorioInadimplencia (props: RelatorioInadimplenciaProps) {
    const data = useData<IInadimplenciaRecord, IInadimplenciaFilter>({
        filter: {
            empresaId: useField(EnumEmpresa.None)
        }
    });
    const loading = useLoading();
    const message = useMessage();
    const empresaCombo = useEmpresaCombo();
    const detalhesModal = useModalWindow();

    const relatorioService = useRelatorioService();

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            relatorioService.listarInadimplencia(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        empresaCombo.loadOptions();
    })

    return (
        <React.Fragment>
            <Main>
                <PageTitle>
                    <PageTitleText text="Relatório de Inadimplência - Por Cliente" />
                </PageTitle>

                <PageContent>
                    <InadimplenciaFilter
                        filter={data.filter}
                        isLoading={loading.isLoading}
                        empresaCombo={empresaCombo}
                    />
                    
                    <TableWrapper>
                        <TableLinearLoading isLoading={loading.isLoading} />
                        <InadimplenciaTable
                            data={data}
                            isLoading={loading.isLoading}
                        />
                    </TableWrapper>
                </PageContent>
            </Main>

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <InadimplenciaDetalhesModal 
                            cliente={data.focusedRow}
                            modal={detalhesModal}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}